import { ProductType } from './ProductType';
import { CustomField } from '../CustomField/CustomField';
import dayjs from 'dayjs';

export interface DtoProduct {
    id: number;
    name: string;
    description: string;
    image: string;
    nonMemberPrice : number;
    memberPrice: number;
    minimumPrice: number;
    active: boolean;
    taxable: boolean;
    requiresFulfillment: boolean;
    weight: number;
    displayOrder: number;
    chargeByDefault: boolean;
    productType: ProductType;
    isSubscription: boolean;
    hasLimitedQuantity: boolean;
    quantityAvailable: number;
    hasPurchaseWindow: boolean;
    purchaseWindowStart: string;
    purchaseWindowEnd: string;
    productsSold: number;
    maxAvailable: number;
    fileNameWithPrefix: string;
    customFields: CustomField[];
    restrictionMessage: string | null;
    restrictionTitle: string | null;
    paymentPlansEnabled: boolean;
}

export class Product implements DtoProduct {
    id!: number;
    name!: string;
    description!: string;
    image!: string;
    nonMemberPrice!: number;
    memberPrice!: number;
    minimumPrice!: number;
    active!: boolean;
    taxable!: boolean;
    requiresFulfillment!: boolean;
    weight!: number;
    displayOrder!: number;
    chargeByDefault!: boolean;
    productType!: ProductType;
    isSubscription!: boolean;
    hasLimitedQuantity!: boolean;
    quantityAvailable!: number;
    hasPurchaseWindow!: boolean;
    purchaseWindowStart!: string;
    purchaseWindowEnd!: string;
    productsSold!: number;
    maxAvailable!: number;
    fileNameWithPrefix!: string;
    customFields!: CustomField[];
    restrictionMessage!: string | null;
    restrictionTitle!: string | null;
    isOnlyVisibleInPurchaseWindow!: boolean;
    paymentPlansEnabled!: boolean;

    constructor(dtoProduct: DtoProduct) {
        Object.assign(this, dtoProduct);
    }
    
    get isWithinPurchaseWindow() {
        return !this.isBeforePurchaseWindow && !this.isAfterPurchaseWindow;
    }

    get isBeforePurchaseWindow() {
        if (!this.hasPurchaseWindow) {
            return false;
        }

        const now = dayjs();
        return this.purchaseWindowStart && now.isBefore(this.purchaseWindowStart);
    }

    get isAfterPurchaseWindow() {
        if (!this.hasPurchaseWindow) {
            return false;
        }

        const now = dayjs();
        return this.purchaseWindowEnd && now.isAfter(this.purchaseWindowEnd);
    }

    get isSoldOut() {
        if (!this.hasLimitedQuantity) {
            return false;
        }

        return this.maxAvailable < 1;
    }

    getProductPrice(isMember: boolean): number {
        return (isMember ? this.memberPrice : this.nonMemberPrice) || 0;
    }

    getProductPriceString(isMember: boolean): string {
        var price = this.getProductPrice(isMember);
        return price ? price.toFixed(2) : "";
    }

    get isLocked() {
        if (this.restrictionMessage) {
            return true;
        }

        return false; 
    }
}


export function createProduct(dtoProduct?: DtoProduct | any) {
    const result = <DtoProduct>{
        id: 0,
        name: '',
        description: '',
        image: '',
        nonMemberPrice: 0,
        memberPrice: 0,
        minimumPrice: 0,
        active: false,
        taxable: false,
        requiresFulfillment: false,
        weight: 0,
        displayOrder: 0,
        chargeByDefault: false,
        productType: ProductType.Paid,
        isSubscription: false,
        hasLimitedQuantity: false,
        quantityAvailable: -1,
        hasPurchaseWindow: false,
        purchaseWindowStart: '',
        purchaseWindowEnd: '',
        productsSold: 0,
        maxAvailable: -1,
        fileNameWithPrefix: '',
        customFields: [],
        restrictionMessage: null,
        restrictionTitle: null,
        paymentPlansEnabled: false
    };
    if (dtoProduct) {
        Object.assign(result, dtoProduct);
    }
    return new Product(result);
}
